import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPipelinePropertiesInputDto, PipelinePropertyCreateDto, PipelinePropertyDto, PipelinePropertyExcelDownloadDto, PipelinePropertyUpdateDto } from '../dtos/pipeline-property/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PipelinePropertyService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: PipelinePropertyCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePropertyDto>({
      method: 'POST',
      url: '/api/operational/pipelineProperties',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/pipelineProperties/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/pipelineProperties',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePropertyDto>({
      method: 'GET',
      url: `/api/operational/pipelineProperties/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/pipelineProperties/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPipelinePropertiesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PipelinePropertyDto>>({
      method: 'GET',
      url: '/api/operational/pipelineProperties',
      params: { name: input.name, zoneId: input.zoneId, propertyTypeId: input.propertyTypeId, periodId: input.periodId, signatureReasonId: input.signatureReasonId, dinamaReasonId: input.dinamaReasonId, millLocationId: input.millLocationId, distanceToMill: input.distanceToMill, distanceToMillFrom: input.distanceToMillFrom, distanceToMillTo: input.distanceToMillTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PipelinePropertyExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/pipelineProperties/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, zoneId: input.zoneId, propertyTypeId: input.propertyTypeId, periodId: input.periodId, signatureReasonId: input.signatureReasonId, dinamaReasonId: input.dinamaReasonId, millLocationId: input.millLocationId, distanceToMill: input.distanceToMill, distanceToMillFrom: input.distanceToMillFrom, distanceToMillTo: input.distanceToMillTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePropertyDto[]>({
      method: 'GET',
      url: '/api/operational/pipelineProperties/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PipelinePropertyUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePropertyDto>({
      method: 'PUT',
      url: `/api/operational/pipelineProperties/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}